import { render, staticRenderFns } from "./TrainingCertificateDoc.vue?vue&type=template&id=5b685165&scoped=true&"
import script from "./TrainingCertificateDoc.vue?vue&type=script&lang=js&"
export * from "./TrainingCertificateDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b685165",
  null
  
)

export default component.exports